"use client";

import type { MinimalGlossaryTerm } from "@/app/(marketing)/(payload)/dictionary/_actions/glossary";
import { cn } from "@/lib/utils";
import { useTranslations } from "next-intl";
import { useMemo } from "react";

export type GlossaryTermCategoryBadgeProps = {
  category: MinimalGlossaryTerm["category"];
};

const CATEGORY_STYLES: Record<
  MinimalGlossaryTerm["category"],
  string
> = {
  valuation: "border-theme-purple/30 bg-muted text-foreground",
  legal: "border-theme-green/30 bg-muted text-foreground",
  process: "border-theme-brown/30 bg-muted text-foreground",
  financing: "border-theme-orange/30 bg-muted text-foreground",
  marketing: "border-theme-red/30 bg-muted text-foreground",
  tech: "border-theme-blue/30 bg-muted text-foreground",
};

export function GlossaryTermCategoryBadge({
  category,
}: GlossaryTermCategoryBadgeProps) {
  const t = useTranslations();

  const label = useMemo(() => {
    return t(`web.glossary.category.${category}`);
  }, [category, t]);

  return (
    <div
      className={cn(
        "rounded-full border px-3 py-[3px] text-sm font-bold uppercase",
        CATEGORY_STYLES[category],
      )}
    >
      {label}
    </div>
  );
}
